import axios from "axios";

import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../config/firebase-config";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Adds a lesson to the DB
export const AddLessonToDB = async (documentID, lessonModule, lessonTitle, courseID, lessonType) => {
  const data = {
    lessonModule: lessonModule,
    lessonTitle: lessonTitle,
    courseID: courseID,
    lessonType: lessonType
  };

  const docRef = doc(db, "lessons", documentID);

  try {
    await setDoc(docRef, data);
    console.log("Added Lesson successfully!");
  } catch (error) {
    console.log(auth.currentUser);
    console.error("Error Adding Lesson: ", error);
  }
};




export const AddPracticeProblemRequest = async (courseID, lessonID, problemNumber) => {

  const body = {
    "courseID": courseID,
    "lessonID": lessonID,
    "problemNumber": problemNumber
  };

  try {
    const response = await axios.post(API_BASE_URL + "/codenec/add-pp", body, { withCredentials: true, });

  } catch (error) {
    console.error("Error fetching user response:", error);
  }

};




export const GetAllLessons = async () => {



  try {

    const response = await axios.get(API_BASE_URL + "/codenec/get-all-lessons");

    const courseArray = response.data;

    return courseArray;




  } catch (error) {
    console.error("Error getAllRegisteredCourses: ", error);
    return [];
  }
}